var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.DatePicker,{attrs:{"value":_setup.value,"modal":true,"auto-open":_setup.pickerOpen,"custom-calendar-icon":true,"data-picker-place-holder":"Select date"},on:{"onApplyDate":_setup.handleApply,"onClose":_setup.handleClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }